<template>
  <div class="entity_notification items-start" :class="{ unseen: !isRead }">
    <ThemeImage
      :icon="imageNames.SUPER_AGI_LOGO_ROUND"
      alt="icon"
      class="min-w-7 min-h-7"
    />
    <div class="flex flex-col gap-[6px] flex-grow min-w-0">
      <span
        class="proxima_nova text-sm font-normal text_color break-words content-wrapper"
      >
        {{ content }}
      </span>
      <div v-if="entityName" class="flex flex-row items-center">
        <ThemeImage :icon="entityIcon" alt="icon" class="w-4 h-4 mr-1" />
        <span class="proxima_nova text-xs font-semibold text_color">{{
          entityName
        }}</span>
      </div>

      <div class="secondary_color text-xs text-nowrap">
        {{ formatTimestamp(createdTime, "timestamp", formatTypes.centered) }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { formatTimestamp } from "@/src/utils/dateTimeUtils.js";
import { formatTypes } from "@/src/constants/dateTimeConstants.js";
import { imageNames } from "@/src/constants/imageConstants.js";

const props = defineProps({
  entityType: {
    type: String,
    default: null,
  },
  entityName: {
    type: String,
    default: null,
  },
  content: {
    type: String,
    required: true,
  },
  createdTime: {
    type: String,
    required: true,
  },
  isRead: {
    type: Boolean,
    required: true,
  },
});

const entityIconMap = {
  company: imageNames.COMPANIES_UNSELECTED,
  contact: imageNames.CONTACTS_UNSELECTED,
  lead: imageNames.LEADS_UNSELECTED,
  deal: imageNames.DEALS_UNSELECTED,
  task: imageNames.TASK_GREY,
};

const entityIcon = computed(() => {
  const entityType = props.entityType?.toLowerCase() || "";
  return entityIconMap[entityType] || imageNames.SUPER_AGI_LOGO_ROUND;
});
</script>

<style scoped>
.entity_notification {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  transition: background-color 0.2s ease-in-out;
  cursor: pointer;
  border-radius: 8px;
}

.entity_notification.unseen {
  border-radius: 8px;
  background: rgba(112, 149, 235, 0.12);
}

.entity_notification:hover {
  background-color: var(--white-opacity-8);
}

.entity_notification.unseen:hover {
  background:
    linear-gradient(
      0deg,
      rgba(255, 255, 255, 0.08) 0%,
      rgba(255, 255, 255, 0.08) 100%
    ),
    rgba(112, 149, 235, 0.12);
}

.content-wrapper {
  word-wrap: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
}
</style>
